import { ROUTER_PATHS } from '@constants/router';

export const DOCS_MENU_ITEMS = [
  { href: ROUTER_PATHS.GUIDES, messageId: 'core.header.docs.guides' },
  { href: ROUTER_PATHS.REFERENCES, messageId: 'core.header.docs.api-reference' },
  // { href: ROUTER_PATHS.GLOSSARY, messageId: 'core.header.docs.glossary' },
  { href: ROUTER_PATHS.COLLECTIONS, messageId: 'core.header.docs.collections' },
  // { href: ROUTER_PATHS.CHANGELOG, messageId: 'core.header.docs.changelog' },
];

export const ACCOUNT_MENU_ITEMS = [
  { href: ROUTER_PATHS.DEVELOPER_HOME, messageId: 'core.header.actions.sign-in' },
  { href: ROUTER_PATHS.SIGN_UP, messageId: 'core.header.actions.sign-up' },
];

export const LEFT_HEADER_PORTAL_ID = 'left-header-portal-id';
export const RIGHT_HEADER_PORTAL_ID = 'right-header-portal-id';
export const LEFT_HEADER_PORTAL_ID_HASH = '#left-header-portal-id';
export const RIGHT_HEADER_PORTAL_ID_HASH = '#right-header-portal-id';
